import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const fetchWishlist = useCallback(async () => {
    if (!user) { setItems([]); return; }
    try {
      const { data } = await api.get("/wishlist");
      setItems(data.products || data.items || []);
    } catch { setItems([]); }
  }, [user]);

  useEffect(() => { if (user) fetchWishlist(); else setItems([]); }, [user, fetchWishlist]);

  const has = useCallback((id) => items.some((i) => {
    if (typeof i === "string") return i === id;
    return (i.product_id || i.id || i._id) === id;
  }), [items]);

  const toggle = useCallback(async (id) => {
    await api.post("/wishlist", { product_id: id });
    await fetchWishlist();
  }, [fetchWishlist]);

  return (
    <WishlistContext.Provider value={{ items, count: items.length, has, toggle, fetchWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
}
